import React, { useCallback, useState } from 'react';
import { Link } from 'gatsby';

import { IconButton, Modal } from 'components/UI';
import useMediaQuery from 'utils/useMediaQuery';

import themeVars from 'theme/vars.scss';

import styles from './nav.module.scss';

const navLinks: { title: string; link: string; }[] = [
  {
    title: 'Home',
    link: '/',
  },
  {
    title: 'Portfolio',
    link: '/portfolio',
  },
  {
    title: 'Insights',
    link: '/insights',
  },
  {
    title: 'Content',
    link: '/content',
  },
  {
    title: 'Talent',
    link: '/talent',
  },
];

const Nav = () => {
  const isVisible = useMediaQuery(`(min-width: ${themeVars.mqSm})`);
  const [isOpened, setIsOpened] = useState(false);

  /* handlers */

  const handleOpen = useCallback(() => {
    setIsOpened(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpened(false);
  }, []);

  /* renderers */

  const renderContent = () => (
    <nav className={styles.nav}>
      {navLinks.filter(({ link }) => (!isVisible || link !== '/')).map(({ title, link }) => (
        <Link
          key={link}
          className={styles.navLink}
          activeClassName={styles.navLinkActive}
          to={link}
        >
          {title}
        </Link>
      ))}
    </nav>
  );

  return (
    <div className={styles.container}>
      {isVisible && renderContent()}
      {!isVisible && (
        <>
          <Modal
            id="nav-modal"
            isOpened={isOpened}
            closePosition="bottom"
            onClose={handleClose}
          >
            {renderContent()}
          </Modal>
          <IconButton
            id="nav-button"
            className={styles.button}
            name="bars"
            onClick={handleOpen}
          />
        </>
      )}
    </div>
  );
};

export default Nav;
